import { ROUTES } from '@platform/router/paths'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$workspaceId/')({
  beforeLoad({ params }) {
    // Set files as our default route endpoint
    throw redirect({ to: ROUTES.files, params })
  },
})
